import {getCountString} from 'ac-share'

function getCountStringCoins(countCoins: number): string {
  return getCountString(countCoins, 'монеты', 'монет', 'монет')
}

export {getCountStringCoins}
